import { render, staticRenderFns } from "./m-rename-file.vue?vue&type=template&id=389f5bd0&"
import script from "./m-rename-file.vue?vue&type=script&lang=js&"
export * from "./m-rename-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports